/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
 */
export enum OrderStatus {
  DRAFT = 'draft',
  CHECKOUT = 'checkout',
  IN_PROGRESS = 'in_progress',
  PAID = 'paid',
  PARTIAL_PAID = 'partial_paid',
  ERROR = 'error',
  CRITICAL = 'critical',
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  PENDING_REFUND = 'pending_refund',
  PENDING = 'pending',
  REFUNDED = 'refunded',
  OVERDUE = 'overdue',
  TERMINATED = 'terminated',
  REFUSED = 'refused',
  SUBMITTED = 'submitted',
  DATA_ENTRY = 'data_entry',
  INSPECTION = 'inspection',
  OFFER_READY = 'offer_ready',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  IN_PROCESSING = 'in_processing',
}
